import React, { useState } from "react";
import { useEffect } from "react";
import { checkSaralIdIsExist } from "../../Utils/APIs/checkSaralIdIsExistAPI.js";
import { insertData } from "../../Utils/APIs/commonInsertAPI.js";
import {district} from '../../data/district.js'
import {taluka} from '../../data/taluka.js';
import {village} from '../../data/village.js';
import CommonDropdownWithStaticList  from '../../Components/common/CommonDropdownWithStaticList.jsx';
import showDataWithPost from '../../Utils/APIs/commonShowWithPost.js'
import axios from "axios";
import { getCookie } from '../../Utils/cookies';


const ComplaintRegister = () => {
  const empData = getCookie('empData') ? JSON.parse(getCookie('empData')) : {};
  console.log("empData" ,empData)
  // console.log("District", district);
  const [farmerDetails, setFarmerDetails] = useState({});
  const [farmerExist, setFarmerExist] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [saralId, setSaralId] = useState("");
  const [complaineeName, setComplaineeName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [address, setAddress] = useState("");
  const [pincode, setPincode] = useState("");
  const [complaintDetails, setComplaintDetails] = useState("");
  const [selectedComplaintType, setSelectedComplaintType] = useState(null);
  const [responseData, setResponseData] = useState("");
  const [districtCode, setDistrictCode] = useState([]);
  const [talukaList, setTalukaList] = useState(null);
  const [talukaCode, setTalukaCode] = useState(null);
  const [villageList, setVillageList] = useState(null);
  const [villageCode, setVillageCode] = useState(null);
  const [maharashtraFarmerList, setMaharashtraFarmerList] = useState([]);

  // Error states
  const [complaineeNameError, setComplaineeNameError] = useState(false);
  const [contactNumberError, setContactNumberError] = useState(false);
  const [complaintTypeError, setComplaintTypeError] = useState(false);
  const [complaintDetailsError, setComplaintDetailsError] = useState(false);
  
  const [complaintTypes, setComplaintTypes] = useState([]);
  const [loading, setLoading] = useState(false);

  const isExistSaralId = async () => {
    await checkSaralIdIsExist(
      saralId,
      setFarmerDetails,
      setFarmerExist,
      setResponseMessage
    );
  };

  const handleComplaintForm = async (e) => {
    e.preventDefault();

    // Validation
    setComplaineeNameError(complaineeName === "");
    setContactNumberError(contactNumber.length < 10);
    setComplaintTypeError(selectedComplaintType === null);
    setComplaintDetailsError(complaintDetails === "");

    if (
      complaineeName &&
      contactNumber.length >= 10 &&
      selectedComplaintType &&
      complaintDetails
    ) {
      const complaintPayload = {
        saralId: saralId,
        complaineeName: complaineeName,
        contactNumber: contactNumber,
        address: address,
        pincode: pincode,
        complaintData: selectedComplaintType,
        complaintDetails: complaintDetails
      };

      console.log("Complaint Payload:", complaintPayload);

      const path = "MSEDCL/complaint_register";
      try {
        const status = await insertData(path, setResponseData, complaintPayload);
        if (status) {
          // Reset form
          setContactNumber("");
          setAddress("");
          setPincode("");
          setComplaintDetails("");
          setSelectedComplaintType(null);
          setComplaineeName("");
          setResponseMessage("");
          setSaralId("");
          setFarmerDetails({});
          setFarmerExist(false);
        }
      } catch (error) {
        console.error("Error submitting complaint:", error);
        setResponseData("Failed to submit complaint. Please try again.");
      }
    }
  };

  useEffect(() => {
    const fetchComplaintTypes = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/MSEDCL/complaint_Type`
        );
        if (response.data.success) {
          setComplaintTypes(response.data.data);
        }
      } catch (error) {
        console.log("Error fetching complaint types:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchComplaintTypes();
  }, []);
  useEffect(() =>{
    setTalukaList(taluka[districtCode]);
    setVillageList(null)
  },[districtCode]);
  useEffect(()=>{
    setVillageList(village[talukaCode])
  },[talukaCode])
  const searchFarmerList = async() =>{
    const payload = {
      "districtCode": districtCode,
      "talukaCode": talukaCode,
      "villageCode": villageCode
    }
    const apiResponse = await showDataWithPost("MSEDCL/farmerList", payload);
    setMaharashtraFarmerList(apiResponse?.data);

  }
  const selectFarmer = (farmerId) =>{
    setSaralId(farmerId);
    setFarmerExist(true)
  }
  useEffect(()=>{
    console.log("Saral Id", saralId);
  },[saralId])
  return (
    <div className="h-full flex flex-col overflow-auto">
      <div>
        <h1 className="text-3xl font-semibold tracking-widest text-center p-2 bg-gray-50 rounded-lg">
          C<span className="text-lg">OMPLAINT</span> R
          <span className="text-lg">EGISTRATION</span> M
          <span className="text-lg">AHARASHTRA</span>
        </h1>
      </div>

      {/* Saral ID Input */}
      {Object.keys(empData).length !== 0 && <div className="grid gap-3 m-6 md:grid-cols-4">
        <div>
          <label
            htmlFor="saral_id"
            className="block mb-2 text-sm font-medium text-gray-900"
          >
            Saral ID<span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            id="saral_id"
            onChange={(e) => setSaralId(e.target.value)}
            value={saralId}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
            placeholder="Saral Id"
            required
          />
        </div>
        <div>
          {saralId && (
            <button
              type="button"
              onClick={isExistSaralId}
              className="text-white mt-7 bg-yellow-500 ml-6 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
            >
              Find
            </button>
          )}
        </div>
        <div>
          <h1
            className="text-2xl tracking-widest"
            style={{
              color:
                responseMessage === "Farmer Exist"
                  ? "rgb(0, 250, 0)"
                  : "rgb(255, 0, 0)",
            }}
          >
            {responseMessage}
          </h1>
        </div>
      </div>}
      <div className="grid gap-3 mx-6 pt-2 md:grid-cols-4">
        <CommonDropdownWithStaticList 
          ListData={district}
          value={null}
          onChange={setDistrictCode}
          label="District"
        />
        <CommonDropdownWithStaticList 
          ListData={talukaList}
          value={null}
          onChange={setTalukaCode}
          label="Taluka"
        />
        <CommonDropdownWithStaticList 
          ListData={villageList}
          value={null}
          onChange={setVillageCode}
          label="Village"
        />
        {
          districtCode !== null && talukaCode !== null && villageCode !== null && 
          <div className="flex justify-center align-middle h-full items-end">
            <button className="bg-blue-500 py-2 text-white rounded-sm w-full" onClick={(e)=>searchFarmerList()}>Search</button>
          </div>
        }
      </div>
      {Object.keys(empData).length !== 0 && farmerDetails && Object.keys(farmerDetails).length > 0 && (
        <table className="table-relative bg-white border mx-6 border-gray-300 rounded-lg">
          <tbody>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Longitude:
              </th>
              <td className="text-gray-700">{farmerDetails.longitude}</td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Latitude:
              </th>
              <td className="text-gray-700">{farmerDetails.latitude}</td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Farmer:
              </th>
              <td className="text-gray-700">{farmerDetails.farmerName}</td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                District:
              </th>
              <td className="text-gray-700">{farmerDetails.district}</td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Contact No.
              </th>
              <td className="text-gray-700">{farmerDetails.contact}</td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Installation Date:
              </th>
              <td className="text-gray-700">
                {farmerDetails.installationDate}
              </td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                State:
              </th>
              <td className="text-gray-700">{farmerDetails.state}</td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Department:
              </th>
              <td className="text-gray-700">{farmerDetails.department}</td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                District:
              </th>
              <td className="text-gray-700">{farmerDetails.district}</td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Product:
              </th>
              <td className="text-gray-700">
                {farmerDetails.HP + "HP " + farmerDetails.AC_DC}
              </td>
            </tr>
            <tr className="bg-gray-100 border-b hover:bg-gray-300">
              <th className="text-left pl-6 text-gray-700 font-semibold">
                Block:
              </th>
              <td className="text-gray-700">{farmerDetails.block}</td>
              <th className="text-left pl-6 text-gray-600 font-semibold">
                Village:
              </th>
              <td className="text-gray-700">{farmerDetails.village}</td>
            </tr>
          </tbody>
        </table>
      )}
      {maharashtraFarmerList && 
        <table className="m-5 text-center">
          <tr className="bg-gray-800 text-white">
            <th className="py-2">#</th>
            <th className="py-2">CONSUMER NUMBER</th>
            <th className="py-2">NAME</th>
            <th className="py-2">MOBILE NO</th>
            <th className="py-2">CIRCLE</th>
            <th className="py-2">Select</th>
          </tr>
          {
            maharashtraFarmerList.length > 0 ? 
            maharashtraFarmerList.map(({CONSUMER_NUMBER, CONSUMER_NAME, MOBILE_NO_N, CIRCLE_NAME },index)=>(
              <tr className="border-b hover:bg-gray-200">
                <td className="pt-2"> {++index}</td>
                <td className="pt-2"> {CONSUMER_NUMBER}</td>
                <td className="pt-2"> {CONSUMER_NAME}</td>
                <td className="pt-2"> {MOBILE_NO_N}</td>
                <td className="pt-2"> {CIRCLE_NAME }</td>
                <td className="">
                  {( saralId ==="" ) &&<button className="bg-blue-500 text-white px-2 py-0 rounded-sm"
                  onClick={(e)=> selectFarmer(CONSUMER_NUMBER)}
                  >select</button>}
                  {( saralId === CONSUMER_NUMBER ) &&<button className="bg-yellow-400 text-black px-2 py-0 rounded-sm"
                  onClick={(e)=> setSaralId("")}
                  >Unselect</button>}
                </td>
              </tr>
            )) :
            <tr className="bg-gray-100">
              <td colSpan="6" className="text-center py-2 text-red-500">No data in MSEDCL database for this selected location</td>
            </tr>
          }
        </table>
      }
      {((farmerDetails && Object.keys(farmerDetails).length > 0) || saralId) && <form onSubmit={handleComplaintForm}>
        <div className="grid gap-3 m-6 md:grid-cols-4">
          <div>
            <label
              htmlFor="complainee_name"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Complainee Name<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="complainee_name"
              value={complaineeName}
              onChange={(e) => setComplaineeName(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
              placeholder="Complainee Name"
            />
            {complaineeNameError && (
              <span className="text-red-500 text-xs ml-2">
                Complainee Name is required.
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="contact_number"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Contact Number<span className="text-red-500">*</span>
            </label>
            <input
              type="number"
              id="contact_number"
              value={contactNumber}
              onChange={(e) => setContactNumber(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
              placeholder="Contact Number"
              maxLength="10"
            />
            {contactNumberError && (
              <span className="text-red-500 text-xs ml-2">
                Contact number must be 10 digits.
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="address"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Address<span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="address"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
              placeholder="Address"
            />
          </div>
          <div>
            <label
              htmlFor="pincode"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              PIN CODE  <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              id="pincode"
              value={pincode}
              onChange={(e) => setPincode(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
              placeholder="Pin code"
              maxLength="6"
            />
          </div>
          <div>
            <label
              htmlFor="complaint_type"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Complaint Type<span className="text-red-500">*</span>
            </label>
            {loading ? (
              <div className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5">
                Loading complaint types...
              </div>
            ) : (
              <select
                id="complaint_type"
                value={
                  selectedComplaintType
                    ? selectedComplaintType.RequestSubTypeID
                    : ""
                }
                onChange={(e) => {
                  const selectedId = e.target.value;
                  const selectedType = complaintTypes.find(
                    (type) => type.RequestSubTypeID.toString() === selectedId
                  );
                  setSelectedComplaintType(selectedType || null);
                }}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block w-full p-2.5"
              >
                <option value="">-- Select Complaint Type --</option>
                {complaintTypes?.length >  0  &&  complaintTypes?.map((type) => (
                  <option
                    key={type.RequestSubTypeID}
                    value={type.RequestSubTypeID}
                  >
                    {type.RequestSubTypeName}
                  </option>
                ))}
              </select>
            )}
            {complaintTypeError && (
              <span className="text-red-500 text-xs ml-2">
                Please select a complaint type
              </span>
            )}
          </div>
          <div>
            <label
              htmlFor="complaint_details"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Complaint Details<span className="text-red-500">*</span>
            </label>
            <textarea
              id="complaint_details"
              value={complaintDetails}
              onChange={(e) => setComplaintDetails(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm block p-2.5 w-full resize-none"
              placeholder="Please describe your complaint"
            />
            {complaintDetailsError && (
              <span className="text-red-500 text-xs ml-2">
                Complaint details are required
              </span>
            )}
          </div>
          <div className="px-6 flex justify-between items-center gap-4 mt-4">
          {farmerExist && (
            <button
              type="submit"
              className="text-white bg-yellow-500 hover:bg-yellow-400 font-medium rounded-sm text-sm w-full sm:w-auto px-5 py-2.5 text-center"
            >
              Submit
            </button>
          )}
        </div>
        </div>

        
      </form>}
      <p className="w-full text-center" style={{ width: "100%", color: "rgb(1, 231, 1)" }}>
            {responseData}
          </p>
    </div>
  );
}

export default ComplaintRegister